<template>
    <div class="main">
        <c-panel>
            <gestao></gestao>
        </c-panel>
    </div>
</template>
<script>

import gestao from "./gestao"

export default {
    components:{ gestao }
}
</script>
